import { Navigate } from 'react-router';
import { Loader2 } from 'lucide-react';
import { useSession } from '@/contexts/session-context';
import { useSuperAdminAccess } from '@/hooks/use-super-admin-access';

export function SuperAdminRoute({ children }: { children: React.ReactNode }) {
  const { isLoading, user } = useSession();
  const { hasAccess: isSuperAdmin, loading: accessLoading } =
    useSuperAdminAccess(user?.email ?? null);

  // Only show loader on initial auth (no user yet). Mid-session token swaps
  // shouldn't unmount children — see protected-route.tsx for the same pattern.
  if (isLoading && !user) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (accessLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
